const activityApi = {
  GETALLACTIVITYTYPES: '/activityType/getTypes', //获取所有活动全部分类
  GETALLSponsor: '/activitySponsor/getSponsors', // 根据分类id获取所以的主办方
  GETALLACTIVE: '/activity/getActivity', //获取所有活动数据
  GETSPONSORLIST: '/activitySponsor/getSponsors', //根据活动类型--获取所有的主办方 type_id 赛事类型id
  UPDETESPONOSOR: '/activitySponsor/updateSponsors', //更改主办方
  ADDSPONSOR: '/activitySponsor/addSponsors', //添加主办方
  DELECTSPONSOR: '/activitySponsor/delete', //删除主办方
  SPONSORMOVE: '/activitySponsor/changeOrder', //主办方上移下移
  ADDACTIVITY: '/activityType/addType', //添加活动分类
  UPDATAACTIVITY: '/activityType/updateType', //更新活动分类
  DELECTACTIVITY: '/activityType/deleteTypes', //删除活动分类
  ACTIVITYMOVE: '/activityType/changeOrder', //活动上移下移
  UPDATEACTIVITYPAGE: '/activity/updateActivity', //更改活动主页的状态
  DELECTACTIVITYPAGE: '/activity/deleteActivity', //删除活动主页的活动
  TOPACTIVITYPAGE: '/activity/topActivity', //置顶活动主页的数据
  ADDACTIVITYPAGE: '/activity/addActivity', //添加活动主页的活动
  GETACTIVITYMEBER: '/activity/activityDetail',//活动训练营的详情
  DELETEITEMMEMBER:'/activity/deleteActivity'//删除某个成员
}
export default activityApi
